import { useMutation } from "@tanstack/react-query";
import { previewProposal } from "../../api/rental-financial-proposal";
import { PreviewProposalDto } from "../../dtos/rental-financial-proposal";

type PreviewResponse = {
  data: ArrayBuffer;
  headers: Record<string, string>;
};

export default function usePreviewProposal() {
  return useMutation<PreviewResponse, Error, PreviewProposalDto>({
    mutationFn: (data: PreviewProposalDto) => previewProposal(data),
  });
}
